export default __webpack_public_path__ + "static/menu-restaurant-interior-1db86d9a87afd1ed7f3f13b30679753e.jpeg";